import helper from '@/urls/helper'

let getRecordingUrlWithParameters = helper.getRecordingUrlWithParameters
let getAdminUrlAllowed = helper.getRecordingUrlAllowed

export default {
    getAdminUrlWithParameters: getRecordingUrlWithParameters,
    ADMIN: {
        ALLOWED: () => getAdminUrlAllowed(
            'event|admin|events-list',
            'list',
        ),

        EVENTS: {
            LIST:
                (gets = null) => getRecordingUrlWithParameters(
                    'event|admin|events-list',
                    'list',
                    gets
                ),
            DETAIL:
                (id, gets = null) => getRecordingUrlWithParameters(
                    'event|admin|events-detail',
                    'update',
                    {id: id},
                    gets
                ),
        },
        RECORDS: {
            TRANSFER:
                (event,id, gets = null) => getRecordingUrlWithParameters(
                    'admin|event|records-transfer',
                    'transfer',
                    {event: event,id: id},
                    gets
                ),
            LIST:
                (event, gets = null) => getRecordingUrlWithParameters(
                    'admin|event|records-list',
                    'list',
                    {event: event},
                    gets
                ),
            DETAIL:
                (token, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|token|record-detail',
                    'retrieve',
                    {token: token},
                    gets
                ),
            DELETE:
                (event, id, gets = null) => getRecordingUrlWithParameters(
                    'admin|event|records-detail',
                    'destroy',
                    {event: event, id: id},
                    gets
                ),
            VISITED:
                (token, gets = null) => getRecordingUrlWithParameters(
                    'admin|token|record-visite',
                    'visite',
                    {token: token },
                    gets
                ),
        },
    }
}
